<template>
  <div>
    <v-data-table :headers="headers" :items="list" :items-per-page="itemsPerPage" :search="search"
      no-data-text="Sin resultados disponibles" class="mx-5" dense fixed-header height="auto" hide-default-footer>
      <template v-slot:[`item.startDate`]="{ item }">
        {{ $utilFront.formatDateTime(item.startDate) }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">

        <div v-if="item.isInterpretanding">
          

          <v-tooltip top v-if="$utilFront.withPermission($prm.INTERPRETATION_UNLOCK)">
            <template v-slot:activator="{ on, attrs }">
              <v-btn small icon @click="confirmUnlockStudy(item)" >
                <v-icon v-bind="attrs" v-on="on" color="error" dense >
                  mdi-lock-open-outline
              </v-icon>
              </v-btn>
            </template>
            <span>Desbloquear estudio</span>
          </v-tooltip>

          <v-tooltip top v-else>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" color="error" dense >
                mdi-block-helper
              </v-icon>
            </template>
            <span>Estudio en interpretación</span>
          </v-tooltip>
        </div>
        <div v-else-if="$utilFront.withPermission($prm.INTERPRETATION_ADD) && !item.isInterpretanding">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small icon @click="validateStudyToInterpret(item)" >
                <v-icon v-bind="attrs" v-on="on" color="secondary" dense>
                  mdi-file-document-edit-outline
                </v-icon>
              </v-btn>
            </template>
            <span>Interpretar</span>
          </v-tooltip>
        </div>
        <div v-else>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" color="error" dense >
                mdi-block-helper
              </v-icon>
            </template>
            <span>Sin permiso de interpretación</span>
          </v-tooltip>
        </div> 





      </template>
    </v-data-table>
    <v-dialog v-model="dialogCancelation" persistent max-width="70%" v-if="dialogCancelation">
      <cancelation-modal :dataModal="dataModal" @closeCancelationDialog="closeCancelationDialog"
        :dialogCancelation="dialogCancelation" />
    </v-dialog>
  </div>
</template>

<script>
import MenuCrud from "@/app/components/base/menu/MenuCrud.vue";
import CancelationModal from "@/app/components/common/CancelationModal.vue";
import InterpretationService from "@/app/services/InterpretationService";
import ColposcopyForm from "@/core/request/ColposcopyForm";


export default {
  name: "SpecialityTable",
  props: {
    list: Array,
    get: Function,
    deleteItem: Function,
    itemsPerPage: Number,
    listAllPagination: Function,
    unlockStudy: Function,
    search: String,
  },
  components: {
    MenuCrud,
    CancelationModal,
  },
  data() {
    return {
      sending: false,
      dialogCancelation: false,
      dataModal: {},
      headers: [
        {
          text: "Id Estudio",
          value: "idStudy",
          sortable: false,
        },
        {
          text: "Id Paciente",
          value: "idPatient",
          align: "center",
          sortable: false,
        },
        {
          text: "Nombre del paciente",
          value: "patient",
          align: "center",
          sortable: false,
        },
        {
          text: "Modalidad",
          value: "modality",
          align: "center",
          sortable: false,
        },
        {
          text: "Estudio",
          value: "studyModality",
          align: "center",
          sortable: false,
        },
        {
          text: "Fecha y hora de inicio del estudio",
          value: "startDate",
          align: "center",
          sortable: false,
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "center",
          width: "5%",
        },
      ],
    };
  },
  methods: {
    checkCancel(item) {
      this.dataModal = {};
      this.dataModal = Object.assign(this.dataModal, item);
      this.dataModal.birthDate = this.$utilFront.formatDate(
        this.dataModal.birthDate
      );
      this.dialogCancelation = true;
    },
    closeCancelationDialog(e) {
      this.dialogCancelation = e;
      this.deleteItem();
    },
    validateStudyToInterpret(item) {
  if (!this.sending) {
    this.sending = true;
    InterpretationService.validateStudyToInterpret(item.idStudy)
      .then(() => {
        return this.get(item.idStudy, 2);  
      })
      .then(() => {
        if (item.modality === 'COLPOSCOPIA') {
          return ColposcopyForm.getColposcopyFormFromInterpretation([13]);
        } else {
          return null;
        }
      })
      .then((respColposcopy) => {
        if (respColposcopy) {
          this.$emit("colposcopyLoaded", respColposcopy.data);
        }
      })
      .catch((e) => {
        this.$utilFront.errorhttp(e);
      })
      .finally(() => {
        this.sending = false;
      });
  }
},


    confirmUnlockStudy({idStudy, patient, studyModality}) {
      this.$swal({
        toast: true,
        title: `¿Desea desbloquear el estudio?`,
        html: `<strong>Id estudio:</strong>  ${idStudy} <br/> <strong>Paciente:</strong> ${patient} <br/> <strong>Estudio:</strong> ${studyModality}`,
        icon: "warning",
        confirmButtonText: "Confirmar",
        showCancelButton: true,
        cancelButtonText: "No",
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }).then((result) => {
        if (result.value) {
            this.unlockStudy(idStudy);
        } 
      });
    }
  },
};
</script>
